import InstructionClient from '../shared/InstructionClient';
import { URL } from '../../../constants/reading/ApiConstants';

const { D8_INSTRUCTION_PM_URL } = URL;

class ReadingInstructionClient extends InstructionClient {
    static getCheckPoints = (staffId, school, classe) =>
        super.getCheckPoints(staffId, school, classe, D8_INSTRUCTION_PM_URL);

    static saveCheckPoint = (staffId, school, classe, grade, period) =>
        super.saveCheckPoint(staffId, school, classe, grade, period, D8_INSTRUCTION_PM_URL);
}

export default ReadingInstructionClient;
